<script setup>
import { useAttrs } from "vue";
import { useMapGetter } from "dashboard/composables/store";

const attrs = useAttrs();
const globalConfig = useMapGetter("globalConfig/get");
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="8" fill="#5B55C4"/>
    <text
      x="8"
      y="11.5"
      font-family="Georgia, serif"
      font-size="9"
      font-weight="bold"
      fill="#5B55C4"
      text-anchor="middle"
    >R</text>
  </svg>
</template>
